import axios from 'axios';
const API_URL = 'https://api2.nestrental.com.br/api';

const http = axios.create({
  baseURL: API_URL
});

export default http;
